export default __webpack_public_path__ + "static/media/tiffIcon.376e9008.svg";